import { render, staticRenderFns } from "./Springsoft.vue?vue&type=template&id=9f5ef644&scoped=true"
import script from "./Springsoft.vue?vue&type=script&lang=js"
export * from "./Springsoft.vue?vue&type=script&lang=js"
import style0 from "./Springsoft.vue?vue&type=style&index=0&id=9f5ef644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5ef644",
  null
  
)

export default component.exports